// Performance monitoring for job loading
class JobLoadingPerformance {
    constructor() {
        this.startTimes = {};
        this.metrics = {};
    }

    start(operation) {
        this.startTimes[operation] = performance.now();
        console.log(`⏱️ Started: ${operation}`);
    }

    end(operation) {
        if (!this.startTimes[operation]) return;
        
        const duration = performance.now() - this.startTimes[operation];
        this.metrics[operation] = duration;
        
        console.log(`✅ Completed: ${operation} in ${duration.toFixed(2)}ms`);
        delete this.startTimes[operation];
        
        return duration;
    }

    getMetrics() {
        return this.metrics;
    }

    logSummary() {
        console.table(this.metrics);
    }
}

export const jobPerformance = new JobLoadingPerformance();